export function storageAvailable(): boolean {
  return typeof localStorage !== 'undefined';
}

export function readStoredEnum<T extends string>(
  key: string,
  allowed: readonly T[],
  fallback: T
): T {
  if (!storageAvailable()) return fallback;
  try {
    const raw = localStorage.getItem(key);
    if (raw && allowed.includes(raw as T)) return raw as T;
  } catch {
    /* ignore */
  }
  return fallback;
}

export function writeStoredEnum<T extends string>(key: string, value: T): void {
  if (!storageAvailable()) return;
  try {
    localStorage.setItem(key, value);
  } catch {
    /* ignore */
  }
}

export function dispatchPreferenceChanged(eventName: string, detail?: unknown): void {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
  } catch {
    /* ignore */
  }
}
